import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useCompetitionsListQuery } from '../../../src/competitions/hooks/useCompetitionsListQuery';
import { WORLD_CUP_COMPETITION_ID } from '../../../src/worldcup/worldcup.constants';
import { getCompetitionHref } from '../../../src/competitions/helpers/competitionNavigation.helper';
import type { CompetitionSummary } from '../../../src/competitions/types/competitions.types';
import { CompetitionsHubView } from './CompetitionsHubView';

/**
 * Competitions hub container (specs/competitions-hub-client).
 * WC routes to its dedicated experience (doubles as its archive); other LIVE/
 * UPCOMING competitions route into /app/competition/[competitionId] (Slice 2).
 */
export function CompetitionsHub() {
  const router = useRouter();
  const { data, isPending, isError, refetch } = useCompetitionsListQuery();

  const resolveOnPress = useCallback(
    (competition: CompetitionSummary): (() => void) | null => {
      const href = getCompetitionHref(competition, WORLD_CUP_COMPETITION_ID);
      if (href == null) return null;
      return () => router.push(href as never);
    },
    [router],
  );

  return (
    <CompetitionsHubView
      competitions={data ?? []}
      isLoading={isPending}
      isError={isError}
      onRetry={() => refetch()}
      resolveOnPress={resolveOnPress}
    />
  );
}
